export function formatDimensions(item) {
    if (!item) return '-';
    const parts = [
        [item.length, 'L'],
        [item.width, 'W'],
        [item.height, 'H'],
    ]
        .filter(([value]) => value != null && value !== '')
        .map(([value, label]) => `${parseInt(value, 10)}${label}`);
    return parts.length ? parts.join(' ') : '-';
}

export function formatWeight(item) {
    if (!item?.total_weight) return '-';
    const parsed = parseFloat(item.total_weight);
    return Number.isNaN(parsed) ? '-' : parsed.toFixed(2);
}

export function formatQuantity(item) {
    const parsed = parseInt(item?.quantity, 10);
    return Number.isNaN(parsed) ? '-' : parsed;
}

export function formatAddress(order) {
    if (!order) return '-';
    const parts = [
        order.dropoff_address,
        [order.dropoff_city, order.dropoff_state].filter(Boolean).join(', '),
        order.dropoff_zip,
    ].filter(Boolean);
    return parts.length ? parts.join(' ') : '-';
}

export function findManifestOfType(item, types) {
    const match = (item?.manifests || []).find((entry) => types.has(entry?.manifest?.type));
    return match?.manifest || null;
}
